import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BadgeModule } from 'primeng/badge';
import { OverlayBadgeModule } from 'primeng/overlaybadge';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { LayoutComponent } from './layout.component';
import { RouterModule, RouterOutlet } from '@angular/router';
import { MenuModule } from 'primeng/menu';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { StyleClassModule } from 'primeng/styleclass';
import { AvatarModule } from 'primeng/avatar';
import { ToastModule } from 'primeng/toast';
import { DrawerModule } from 'primeng/drawer';
import { TooltipModule } from 'primeng/tooltip';
import { NotificationsListComponent } from '@lib/components';

@NgModule({
  declarations: [LayoutComponent],
  imports: [
    CommonModule,
    BadgeModule,
    OverlayBadgeModule,
    OverlayPanelModule,
    RouterOutlet,
    RouterModule,
    ButtonModule,
    MenuModule,
    RippleModule,
    StyleClassModule,
    AvatarModule,
    ToastModule,
    DrawerModule,
    TooltipModule,
    NotificationsListComponent,
  ],
  exports: [LayoutComponent],
})
export class LayoutModule {}
